import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, my real Vietnamese name is <span className="purple">Tran Dat </span>  but feel
            free to call me <span className="purple">Victor</span>. I'm full-stack developer based in 
             <span className="purple">  Ho Chi Minh city, Vietnam.</span>
            <br />
            I am currently employed as a software developer at XBorderTech.
            <br />
            I graduated with a Bachelor of Science in Information Technology
             from Open University - Ho Chi Minh City.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "There are no secret to success. It is the result of preparation, hard word and learning from failure"{" "}
          </p>
          <footer className="blockquote-footer">Victor Tran</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
